module.exports = __webpack_public_path__ + "static/media/SVG_close_icon.d8bb5461.svg";